/* eslint-disable react/jsx-props-no-spreading */
const StatJobsIcon = (props) => (
	<svg width={64} height={64} viewBox="0 0 64 64" {...props}>
		<g fill="none" fillRule="evenodd">
			<rect width={64} height={64} fill="#FFD166" rx={24} />
			<g transform="translate(22 23)">
				<path
					fill="#FFF"
					stroke="#4D3951"
					strokeLinejoin="round"
					strokeWidth={2}
					d="M1 11h18v6a2 2 0 01-2 2H3a2 2 0 01-2-2v-6z"
				/>
				<rect
					width={8}
					height={7}
					x={6}
					stroke="#4D3951"
					strokeLinejoin="round"
					strokeWidth={2}
					rx={2}
				/>
				<path
					fill="#FFF"
					stroke="#4D3951"
					strokeLinejoin="round"
					strokeWidth={2}
					d="M0 3h20v6a4 4 0 01-4 4H4a4 4 0 01-4-4V3z"
				/>
				<path fill="#4D3951" d="M9 10h2v4H9z" />
			</g>
		</g>
	</svg>
);

export default StatJobsIcon;
